<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Email</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="mt-4 container mx-auto">
    @if (choice) {
      <h3 class="text-center">
        Esse processo ira alterar a proposta para
        <strong>enviado para cliente</strong>, deseja enviar o email via
        sistema?
      </h3>
      <div class="flex justify-around items-center mt-5 -mx-2">
        <button mat-flat-button class="btn-tg w-1/12" (click)="sendEmail(true)">
          Sim
        </button>
        <button
          mat-flat-button
          class="btn-tg-cancel w-1/12"
          (click)="sendEmail(false)"
        >
          Não
        </button>
      </div>
    } @else {
      @if (!loading) {
        @if (success) {
          <h3 class="text-center">Email enviado com sucesso</h3>
          <mat-list role="list">
            @if (infos.emailSolicitante != '') {
              <mat-list-item role="listitem"
                ><strong>Solicitante: </strong>
                {{ infos.emailSolicitante }}</mat-list-item
              >
            }
            @if (infos.emailConsultor != '') {
              <mat-list-item role="listitem">
                <strong>Consultor Cliente: </strong> {{ infos.emailConsultor }}
              </mat-list-item>
            }
            @if (infos.emailConsultorComercial != '') {
              <mat-list-item role="listitem">
                <strong>Consultor Comercial: </strong>
                {{ infos.emailConsultorComercial }}
              </mat-list-item>
            }
          </mat-list>
        } @else {
          <h3 class="text-center">
            Erro ao enviar email, tente novamente mais tarde!
          </h3>
        }
      } @else {
        <mat-divider></mat-divider>
        <div class="flex flex-col items-center gap-4">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          <h3 class="text-center">
            Aguarde!<br />
            Enviando email.
          </h3>
        </div>
      }
    }
  </div>
</mat-card>
